import { useEffect, useState } from 'react'
import { uploadImages } from '../../services/api'

export const useRGFront = (creditPath, goToNextScreen, setIsLoading) => {
  const [files, setFiles] = useState([])
  const [filesUploaded, setFilesUploaded] = useState([])

  useEffect(() => {
    setFilesUploaded(creditPath?.readPersonalDocument?.map(({ data, ...file }) => ({ url: data, ...file })) || [])
  }, [creditPath])

  const onClickNextScreen = async () => {
    setIsLoading(true)
    const urls = await uploadImages(files, { documentType: 'personal-document' })

    goToNextScreen({
      data: [...filesUploaded, ...urls],
    })
  }

  return [onClickNextScreen, files, setFiles, filesUploaded, setFilesUploaded]
}
